import React from 'react'
import * as ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { formValidityPolyfill } from './iePolyfills';
import './index.css'
import {Provider} from "react-redux"
import { store } from './app/store';

if (process.env.NODE_ENV !== 'production') {
	document.cookie = 'es_ttl=test'
}

if (!HTMLFormElement.prototype.reportValidity) {
	formValidityPolyfill()
}

ReactDOM.render(
	<BrowserRouter basename={'/'}>
    <Provider store={store}>
		  <App />
    </Provider>
	</BrowserRouter>,
	document.getElementById('root') as HTMLElement,
)

if ('serviceWorker' in navigator) {
	navigator.serviceWorker.ready.then((registration) => {
		registration.unregister()
	})
}
